"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreTokenSchema = exports.PromotionSchema = exports.ProductPromotionSchema = exports.AnimalPromotionSchema = exports.SecurityCodeSchema = exports.AssetProfileSchema = exports.PlantSchema = exports.AngusSireGroupSchema = exports.AngusSireSchema = exports.AngusMobSchema = exports.AngusCalveSchema = exports.ConsignmentSchema = exports.ConsigneeSchema = exports.SireSchema = exports.GroupSchema = exports.SiteSchema = exports.BrandSchema = exports.ProductSchema = exports.AssetSchema = exports.BusinessSchema = exports.OthersBusinessDetailSchema = exports.ProductBusinessDetailSchema = exports.PlantBusinessDetailSchema = exports.AnimalBusinessDetailSchema = exports.UserSchema = exports.CreateTokenGeneralSchema = void 0;
const zod_1 = require("zod");
const SiteMisc = __importStar(require("../misc/site"));
const TokenMisc = __importStar(require("../misc/token"));
const GroupMisc = __importStar(require("../misc/group"));
const BrandMisc = __importStar(require("../misc/brand"));
const TokenModel = __importStar(require("../model/token"));
const ProductMisc = __importStar(require("../misc/product"));
const BusinessMisc = __importStar(require("../misc/business"));
const AngusMobMisc = __importStar(require("../misc/angusMob"));
const AngusSireMisc = __importStar(require("../misc/angusSire"));
const PromotionMisc = __importStar(require("../misc/promotion"));
const AngusCalveMisc = __importStar(require("../misc/angusCalve"));
const ConsignmentMisc = __importStar(require("../misc/consignment"));
exports.CreateTokenGeneralSchema = zod_1.z.object({
    businessId: zod_1.z.string().optional(),
    tokenId: zod_1.z.string().optional(),
    userId: zod_1.z.string().optional(),
    generateAgliveToken: zod_1.z.boolean().optional(),
    externalIds: TokenMisc.ExternalIdsSchema.optional(),
    uniqueExternalIds: zod_1.z.array(zod_1.z.string()).optional(),
    contractAddress: zod_1.z.string().optional(),
    walletAddress: zod_1.z.string().optional(),
    groupDetails: GroupMisc.GroupLinkSchema.optional(),
    skipAngusAPI: zod_1.z.boolean().optional(),
    nlisUserId: zod_1.z.string().optional(),
    nlisPassword: zod_1.z.string().optional(),
    nlisEmail: zod_1.z.string().optional(),
    generateUniqueAmount: zod_1.z.boolean().optional(),
    amount: zod_1.z.number().optional(),
});
//User Token
exports.UserSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.user),
    details: zod_1.z.object({
        externalIds: TokenMisc.ExternalIdsSchema.optional(),
    })
}).merge(exports.CreateTokenGeneralSchema);
//Business Token
exports.AnimalBusinessDetailSchema = BusinessMisc.AnimalBusinessDetailSchema.merge(BusinessMisc.GeneralBusinessProfileSchema);
exports.PlantBusinessDetailSchema = BusinessMisc.PlantBusinessDetailSchema.merge(BusinessMisc.GeneralBusinessProfileSchema);
exports.ProductBusinessDetailSchema = BusinessMisc.ProductBusinessDetailSchema.merge(BusinessMisc.GeneralBusinessProfileSchema);
exports.OthersBusinessDetailSchema = BusinessMisc.OthersBusinessDetailSchema.merge(BusinessMisc.GeneralBusinessProfileSchema);
// export const AnimalBusinessSchema = z.object({
//     type: z.literal(TokenMisc.tokenTypesSchema.enum.business),
//     details: AnimalBusinessDetailSchema
// }).merge(CreateTokenGeneralSchema)
// export const PlantBusinessSchema = z.object({
//     type: z.literal(TokenMisc.tokenTypesSchema.enum.business),
//     details: PlantBusinessDetailSchema
// }).merge(CreateTokenGeneralSchema)
// export const ProductBusinessSchema = z.object({
//     type: z.literal(TokenMisc.tokenTypesSchema.enum.business),
//     details: ProductBusinessDetailSchema
// }).merge(CreateTokenGeneralSchema)
// export const OthersBusinessSchema = z.object({
//     type: z.literal(TokenMisc.tokenTypesSchema.enum.business),
//     details: OthersBusinessDetailSchema
// }).merge(CreateTokenGeneralSchema)
// export const BusinessSchema = z.union([AnimalBusinessSchema, PlantBusinessSchema, ProductBusinessSchema, OthersBusinessSchema])
exports.BusinessSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.business),
    details: zod_1.z.union([exports.AnimalBusinessDetailSchema, exports.PlantBusinessDetailSchema, exports.ProductBusinessDetailSchema, exports.OthersBusinessDetailSchema])
}).merge(exports.CreateTokenGeneralSchema);
//Asset Token
exports.AssetSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.asset),
    details: zod_1.z.object({
        external_identify: zod_1.z.string().optional(),
        lot_id: zod_1.z.number().optional(),
        lot_name: zod_1.z.string().optional(),
        paddock_id: zod_1.z.string().optional(),
        paddock_name: zod_1.z.string().optional(),
        pen_id: zod_1.z.string().optional(),
        pen_name: zod_1.z.string().optional(),
        unit: zod_1.z.string().optional(),
        species: zod_1.z.string().optional(),
        species_type: zod_1.z.string().optional(),
        breed: zod_1.z.string().optional(),
        breed_type: zod_1.z.string().optional(),
        induction_weight: zod_1.z.number().optional(),
        breeder_pic_id: zod_1.z.string().optional(),
        breeder_pic_name: zod_1.z.string().optional(),
        origin_pic_id: zod_1.z.string().optional(),
        origin_pic_name: zod_1.z.string().optional(),
        maturity: zod_1.z.string().optional(),
        sex: zod_1.z.string().optional(),
        date_of_birth: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).optional(),
        weight_at_birth: zod_1.z.number().optional(),
        shearing_date: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).optional(),
        eartagmark_name: zod_1.z.string().optional(),
        eartag_pic: zod_1.z.string().optional(),
        pic_name: zod_1.z.string().optional(),
        pic_id: zod_1.z.string().optional(),
        induction_date: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).optional(),
        externalIds: TokenMisc.ExternalIdsSchema.optional(),
    })
}).merge(exports.CreateTokenGeneralSchema);
//Product Token
exports.ProductSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.product),
    details: zod_1.z.object({
        name: zod_1.z.string(),
        brand: TokenMisc.ExternalIdsSchema,
        pages: zod_1.z.array(ProductMisc.iProductPageSchema),
        showDeliveryHistory: zod_1.z.boolean(),
        externalIds: TokenMisc.ExternalIdsSchema.optional(),
    })
}).merge(exports.CreateTokenGeneralSchema);
//Brand Token
exports.BrandSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.brand),
    details: zod_1.z.object({
        name: zod_1.z.string(),
        launchScreen: BrandMisc.LaunchDisplaySchema,
        aboutUs: BrandMisc.AboutUsDisplaySchema,
        products: zod_1.z.array(TokenMisc.ExternalIdsSchema),
        externalIds: TokenMisc.ExternalIdsSchema.optional(),
        business: BrandMisc.BusinessBrandSchema
    })
}).merge(exports.CreateTokenGeneralSchema);
//Site Token
exports.SiteSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.site),
    details: zod_1.z.object({
        siteName: zod_1.z.string(),
        location: zod_1.z.string(),
        children: zod_1.z.array(SiteMisc.LayerNodeSchema)
    })
}).merge(exports.CreateTokenGeneralSchema);
//Group Token
exports.GroupSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.group),
    details: GroupMisc.GroupDetailSchema,
    linkToExistingGroup: zod_1.z.boolean(),
    createNewGroup: zod_1.z.boolean(),
}).merge(exports.CreateTokenGeneralSchema);
//Sire Token
exports.SireSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.sire),
    details: zod_1.z.object({
        externalIds: TokenMisc.ExternalIdsSchema.optional(),
    }),
}).merge(exports.CreateTokenGeneralSchema);
//Consignee Token
exports.ConsigneeSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.consignee),
    details: TokenMisc.ConsigneeDetailSchema
}).merge(exports.CreateTokenGeneralSchema);
//Consigment Token
exports.ConsignmentSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.consignment),
    details: zod_1.z.object({
        name: zod_1.z.string(),
        consignee: zod_1.z.object({
            id: zod_1.z.string(),
            pic: zod_1.z.string()
        }).optional(),
        animalSelectionMode: zod_1.z.enum([
            "Individual Animal Selection",
            "Group/Mob Selection",
            "CSV file Selection",
            "plant",
            "product"
        ]),
        csvFile: zod_1.z.object({
            name: zod_1.z.string(),
            link: zod_1.z.string()
        }).optional(),
        mob: zod_1.z.object({
            id: zod_1.z.string(),
            name: zod_1.z.string(),
            type: zod_1.z.string()
        }).optional(),
        assets: zod_1.z.array(zod_1.z.object({
            rfid: zod_1.z.string().optional(),
            agliveToken: zod_1.z.string().optional(),
            nlis: zod_1.z.string().optional(),
            birthYear: zod_1.z.string().optional(),
            mob: zod_1.z.string().optional()
        })).optional(),
        origin: BusinessMisc.AustraliaLocationSchema.optional(),
        declaration: zod_1.z.object({
            userId: zod_1.z.string(),
            accept: zod_1.z.boolean(),
            date: zod_1.z.string(),
        }).optional(),
        forms: zod_1.z.array(ConsignmentMisc.FormTypeSchema).optional(),
        answers: zod_1.z.array(ConsignmentMisc.FormAnswerSchema).optional(),
        template: zod_1.z.array(zod_1.z.object({
            docId: zod_1.z.string(),
            name: zod_1.z.string(),
            type: ConsignmentMisc.FormTypeSchema
        })).optional(),
        externalIds: TokenMisc.ExternalIdsSchema
    })
}).merge(exports.CreateTokenGeneralSchema);
//Angus Calve Token
exports.AngusCalveSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusCalve),
    details: AngusCalveMisc.AngusCalveProfileSchema,
    // skipAngusAPI: z.boolean(),
    // nlisUserId: z.string(),
    // nlisPassword: z.string(),
    // nlisEmail: z.string(),
}).merge(exports.CreateTokenGeneralSchema);
//Angus Mob Token
exports.AngusMobSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusMob),
    details: AngusMobMisc.AngusMobDetailSchema,
    // skipAngusAPI: z.boolean(),
    // nlisUserId: z.string(),
    // nlisPassword: z.string(),
    // nlisEmail: z.string(),
}).merge(exports.CreateTokenGeneralSchema);
//Angus Sire Token
exports.AngusSireSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusSire),
    details: AngusSireMisc.SireProfileSchema.merge(AngusSireMisc.SireSchema),
    // nlisUserId: z.string(),
    // nlisPassword: z.string(),
    // nlisEmail: z.string(),
    sireArray: zod_1.z.array(AngusSireMisc.SireSchema).optional(),
    documentArray: zod_1.z.array(TokenModel.AngusSireSchema).optional()
}).merge(exports.CreateTokenGeneralSchema);
//Angus Sire Group Token
exports.AngusSireGroupSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.angusSireGroup),
    details: zod_1.z.object({
        sire_group_id: zod_1.z.string(),
        group_name: zod_1.z.string(),
        calving_year: zod_1.z.string(),
        acct_id: zod_1.z.string(),
        angusAuthToken: zod_1.z.string(),
        group_sires: zod_1.z.array(AngusSireMisc.SireSchema.omit({ pic: true })),
        joining_method: zod_1.z.string(),
    }),
    // skipAngusAPI: z.boolean(),
    // nlisUserId: z.string(),
    // nlisPassword: z.string(),
    // nlisEmail: z.string(),
}).merge(exports.CreateTokenGeneralSchema);
//Plant Token
exports.PlantSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.plant),
    details: zod_1.z.object({
        assetProfile: TokenMisc.ExternalIdsSchema,
        site: zod_1.z.string(),
        pic_id: zod_1.z.string()
    }),
    // generateUniqueAmount: z.boolean(),
    // amount: z.number(),
}).merge(exports.CreateTokenGeneralSchema);
//Asset Profile Token
exports.AssetProfileSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.assetProfile),
    details: zod_1.z.object({
        assetName: zod_1.z.string(),
        createdBy: zod_1.z.string().optional(),
        archived: zod_1.z.boolean(),
    })
}).merge(exports.CreateTokenGeneralSchema);
//Security Code Token
exports.SecurityCodeSchema = zod_1.z.object({
    type: TokenModel.securityCodeType,
    details: zod_1.z.object({
        product: TokenMisc.ExternalIdsSchema,
        container: TokenModel.securityCodeType,
        date: zod_1.z.date(),
        source: zod_1.z.object({
            companyName: zod_1.z.string(),
            companyNumber: zod_1.z.string(),
            creatorEmail: zod_1.z.string()
        })
    })
}).merge(exports.CreateTokenGeneralSchema);
//Promotion Token
exports.AnimalPromotionSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.promotion),
    details: PromotionMisc.GeneralPromotionDetails.merge(PromotionMisc.AnimalPromotionDetailSchema)
}).merge(exports.CreateTokenGeneralSchema);
exports.ProductPromotionSchema = zod_1.z.object({
    type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.promotion),
    details: PromotionMisc.GeneralPromotionDetails.merge(PromotionMisc.ProductPromotionDetailSchema)
}).merge(exports.CreateTokenGeneralSchema);
exports.PromotionSchema = zod_1.z.union([exports.AnimalPromotionSchema, exports.ProductPromotionSchema]);
exports.PreTokenSchema = zod_1.z.union([exports.UserSchema, exports.AssetSchema, exports.BusinessSchema, exports.ConsignmentSchema, exports.SireSchema, exports.ProductSchema, exports.BrandSchema, exports.GroupSchema, exports.AngusSireSchema, exports.AngusMobSchema, exports.AngusSireGroupSchema, exports.AngusCalveSchema, exports.PlantSchema, exports.AssetProfileSchema, exports.AnimalPromotionSchema, exports.ProductPromotionSchema, exports.SecurityCodeSchema, exports.AnimalPromotionSchema, exports.ProductPromotionSchema]);
